module.exports = __webpack_public_path__ + "fonts/bc65c2d348d4bb8f69e6fb1152b9e777.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/scenes/TripDetails/components/RegionSelect/img/icon_europe_unselected_area2.svg
// module id = 1437
// module chunks = 0